<template>
  <div>
    <div class="row">
      <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder) || userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
        <FinancialBreakdownWidget :filter="filter" />
      </div>
    </div>
    
    <div class="row" v-if="(userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder) || userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount))">
      <div class="col-12" >
        <SalesSummaryWidget :filter="filter" />
      </div>     
    </div>

    <div class="row" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
      <div class="col-12">
        <OrderProductionBreakdownWidget :gridHeight="260" />
      </div>
    </div>

    <div class="row" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="700" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-order-daily">
              <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily</div>
                <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-order-monthly">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Monthly</div>
                <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-order-yearly">
              <i class="tabbedbox-tab-icon fas fa-calendar"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Yearly</div>
                <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-order-daily" class="tabpage-padding-0">
              <OrderDailyChartWidget :filter="filter" :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-order-monthly" class="tabpage-padding-0">
              <OrderMonthlyChartWidget :filter="filter" :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-order-yearly" class="tabpage-padding-0">
              <OrderYearlyChartWidget :filter="filter" :gridHeight="540" :embedded="true" />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>
    <div class="row" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
      <div class="col-6">
        <OrderValueChartWidget :filter="filter" :type="OrderValueChartTypes.orderValueGlass" title="Today's Orders By Glass" subTitle="Today's order value broken down by glass stock type" :gridHeight="500" :showLegend="false" />
      </div>
      <div class="col-6">
        <OrderValueChartWidget :filter="filter" :type="OrderValueChartTypes.orderValuePriceGroup" title="Today's Orders By Price Group" subTitle="Today's order value broken down by price group" :gridHeight="500" :showLegend="false" />
      </div>
    </div>

    <div class="row" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
      <div class="col-12">
        <AccountsReceivableSummaryWidget :filter="filter" :gridHeight="320" />
      </div>
    </div>

    <div class="row" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="600" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-invoice-daily">
              <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily</div>
                <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-invoice-monthly">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Monthly</div>
                <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-invoice-daily" class="tabpage-padding-0">
              <InvoiceDailyChartWidget :filter="filter" :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-invoice-monthly" class="tabpage-padding-0">
              <InvoiceMonthlyChartWidget :filter="filter" :gridHeight="540" :embedded="true" />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>
  </div>
</template>


<script>
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'

import SalesSummaryWidget from '@/modules/intelligence/dashboardWidgets/salesSummaryWidget'
import OrderProductionBreakdownWidget from '@/modules/intelligence/dashboardWidgets/orderProductionBreakdownWidget'
import AccountsReceivableSummaryWidget from '@/modules/intelligence/dashboardWidgets/accountsReceivableSummaryWidget'
import FinancialBreakdownWidget from '@/modules/intelligence/dashboardWidgets/financialBreakdownWidget'
import OrderValueChartWidget from '@/modules/intelligence/dashboardWidgets/orderValueChartWidget'
import OrderDailyChartWidget from '@/modules/intelligence/dashboardWidgets/orderDailyChartWidget'
import OrderMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/orderMonthlyChartWidget'
import OrderYearlyChartWidget from '@/modules/intelligence/dashboardWidgets/orderYearlyChartWidget'
import InvoiceDailyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceDailyChartWidget'
import InvoiceMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceMonthlyChartWidget'

export default {
  name: 'AnalyticsOverviewDashboard',
  components: {
    DashboardContentBox,
    DashboardTabbedContentBox,

    SalesSummaryWidget,
    OrderProductionBreakdownWidget,
    AccountsReceivableSummaryWidget,
    FinancialBreakdownWidget,
    OrderValueChartWidget,
    OrderDailyChartWidget,
    OrderMonthlyChartWidget,
    OrderYearlyChartWidget,
    InvoiceDailyChartWidget,
    InvoiceMonthlyChartWidget
  },
  props: {
    filter: Object
  },
  created() {
    this.OrderValueChartTypes = OrderValueChartWidget.OrderValueChartTypes
  },
  
}
</script>